<template>
  <div id="app">
    <Header />
    <main>
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

/**
 * App
 * Punto de entrada principal de la aplicación.
 * Carga el layout común de la web (header, contenido por ruta y footer)
 * para que cada vista se renderice dentro de la misma estructura global.
 */
export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
@import './styles/main.css';

main {
  min-height: 100vh;
}
</style>